<script lang="ts">
  import { onMount } from "svelte";
  import { initSubmissionsList, records, sourceCode, compilerId, submitSolution, reloadUserSubmissions, editSubmissionCode } from "./task-submission.store";
  import FormField from "../../components/Form/FormField.svelte";
  import { formatTimestampHuman } from "../../utils/date-utils";
  import ClfDropdown from "../../components/Form/Fields/Dropdown/ClfDropdown.svelte";
  import { submissionStatus } from "../../utils/submission-utils";
  import Button from "../../components/Button.svelte";
  import Icon from "../../components/Icon.svelte";
  import AceEditorField from "../../components/Form/Fields/AceEditorField.svelte";
  import Label from "../../components/Form/Label.svelte";
  import FileUploadButton from "../../components/FileUploadButton.svelte";
  import { SubmissionService } from "../../services/submission.service";
  import { ChallengePage } from "./challenge-tab";
  import TaskSubmissionLayout from "./TaskSubmissionLayout.svelte";

  export let sectionId: number;
  export let challengeId: number;

  $: canSubmit = $sourceCode != "" && $compilerId != 0;
  // $: canSubmit = watchSource($sourceCode, $compilerId);
  // function watchSource(src: string, cid: number) {
  //   return src != "" && cid != 0;
  // }

  async function onSubmit() {
    await submitSolution();
  }

  async function onUploadFile(evt: CustomEvent) {
    const b: Blob = evt.detail;
    if (!!b) {
      let text = await b.text();
      sourceCode.set(text);
    }
  }

  function onEditClick(submissionId: number) {
    editSubmissionCode(submissionId);
  }

  function onDownloadClick(submissionId: number) {
    SubmissionService.exportSubmissionSourceCode(submissionId);
  }

  onMount(() => initSubmissionsList(sectionId, challengeId));
</script>

<TaskSubmissionLayout {sectionId} {challengeId} currentTab={ChallengePage.Submissions}>
  <div class="content box">
    <h2 class="subtitle">Submit your solution</h2>

    <div class="submission-input">
      <div class="columns">
        <div class="column is-4">
          <FormField>
            <ClfDropdown name="Compiler" schema="COMPLRTYPE" required={true} clearVisible={false} bind:value={$compilerId} />
          </FormField>
        </div>
        <div class="column is-4">
          <FormField>
            <Label>&nbsp;</Label>
            <Button klass="is-warning" disabled={!canSubmit} on:click={onSubmit}>
              <Icon name="upload_file" handleClick={false} />
              <span>Submit solution</span>
            </Button>
          </FormField>
        </div>

        <div class="column is-4 has-text-right">
          <FormField>
            <Label>&nbsp;</Label>
            <!--
              <Button klass="is-primary" on:click={onUploadFile}>
                <Icon name="note_add" handleClick={false} />
                <span>Upload file</span>
              </Button>
            -->
            <FileUploadButton text="Upload file" on:fileUpload={onUploadFile} />
          </FormField>
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <FormField>
            <!-- <Textarea name="" placeholder="Write your code here." required={false} bind:value={$sourceCode} /> -->
            <AceEditorField name="" bind:value={$sourceCode} />
          </FormField>
        </div>
      </div>
    </div>
  </div>

  <div class="submission-stats content box">
    <h2 class="subtitle">My Submissions</h2>
    <div class="refresh-button">
      <Button klass="is-primary" on:click={(_) => reloadUserSubmissions()}>
        <Icon name="refresh" />
        <span>Refresh</span>
      </Button>
    </div>

    <table class="submissions-table">
      <tr>
        <th>ID</th>
        <th>Date Time</th>
        <th>Compilation</th>
        <th>Score</th>
        <th>Edit</th>
        <th>File</th>
      </tr>
      {#if $records}
        {#each $records as submission}
          <tr>
            <td>
              {#if submission.evaluated == 1}
                <a href="/task/{sectionId}/{challengeId}/submission/{submission.oid}" title="View Results">{submission.oid}</a>
              {:else}
                {submission.oid}
              {/if}
            </td>
            <td>{formatTimestampHuman(submission.createdOn)}</td>
            <td>{submissionStatus(submission)}</td>
            <td>{submission.points}%</td>
            <!-- svelte-ignore a11y-missing-attribute -->
            <!-- svelte-ignore a11y-no-static-element-interactions -->
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <td><a on:click={(_) => onEditClick(submission.oid)}>Edit</a></td>
            <!-- svelte-ignore a11y-missing-attribute -->
            <!-- svelte-ignore a11y-no-static-element-interactions -->
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <td><a on:click={(_) => onDownloadClick(submission.oid)}>Download</a></td>
          </tr>
        {/each}
        {#if $records.length == 0}
          <tr>
            <td colspan="6" class="has-text-centered">no submissions yet</td>
          </tr>
        {/if}
      {/if}

      <!--
        <tr>
          <td>1234</td>
          <td>2023-04-15 12:33:44</td>
          <td>100 / 100</td>
          <td>Download</td>
        </tr>
        <tr>
          <td>1234</td>
          <td>2023-04-15 12:33:44</td>
          <td>100 / 100</td>
          <td>Download</td>
        </tr>
      -->
    </table>
  </div>
</TaskSubmissionLayout>

<style>
  .submission-input {
    display: flex;
    flex-direction: column;
  }

  .submission-stats {
    position: relative;
  }

  .submissions-table {
    border: 1px solid #ccc;
  }

  .refresh-button {
    position: absolute;
    top: 1.25rem;
    right: 1.25rem;
  }
</style>
